/* Publish by EComposer at 2026-09-29 09:32:16*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-dhayot5uc3l"]=  window.__ectimmers["ecom-dhayot5uc3l"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-dhayot5uc3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dhayot5uc3l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z5om9ma5llm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z5om9ma5llm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wu215glfwsr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wu215glfwsr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gvwvpegdm6k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gvwvpegdm6k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-04iaq3c8rss9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-04iaq3c8rss9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7vtqraf64ym').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7vtqraf64ym', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-peb9w3r4q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-peb9w3r4q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hvzdsr3apgb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hvzdsr3apgb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7jjt637smjo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7jjt637smjo', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-zxnutkmw17"]=  window.__ectimmers["ecom-zxnutkmw17"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-zxnutkmw17"]["wmszobui9"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-zxnutkmw17').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zxnutkmw17', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n2c8ampp9p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n2c8ampp9p', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-070orn46fhfl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-070orn46fhfl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0f15jmxbi39m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0f15jmxbi39m', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-01krmax7rfnl"]=  window.__ectimmers["ecom-01krmax7rfnl"] || {};
if(!this.$el||!window.EComModal)return;const t=this.isLive;let e=this.$el.querySelectorAll("[ecom-modal]");e.length&&t&&new window.EComModal(e,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})

                    });
                    
                        document.querySelectorAll('.ecom-01krmax7rfnl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-01krmax7rfnl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ulmz65w5l68').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ulmz65w5l68', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o9mb27dl0d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o9mb27dl0d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gefed0cyfo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gefed0cyfo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-199hx7l1auj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-199hx7l1auj', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}